import { render } from "./HistoryMenu.vue?vue&type=template&id=a90a95d0"
import script from "./HistoryMenu.vue?vue&type=script&lang=js"
export * from "./HistoryMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__